import { render, staticRenderFns } from "./ApplyForRoleModal.vue?vue&type=template&id=01aea119&scoped=true&"
import script from "./ApplyForRoleModal.vue?vue&type=script&setup=true&lang=ts&"
export * from "./ApplyForRoleModal.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./ApplyForRoleModal.vue?vue&type=style&index=0&id=01aea119&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01aea119",
  null
  
)

export default component.exports